import React, { memo, Suspense, useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import GameFeatureImage1 from './gameFeatureImage1/GameFeatureImage1';
import GameNavBar1 from './gameNavBar1/GameNavBar1';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { context } from '../../../globalState/GlobalState';
import GalleryComponent1 from '../../uiElements/galleryComponents/galleryComponent1/GalleryComponent1';
import ArticleComponent1 from '../../uiElements/articleComponents/articleComponent1/ArticleComponent1';
import GameRoster1 from './gameRoster1/GameRoster1';
import IceHockeyGameStats1 from './gameStats1/IceHockeyGameStats1';
import GameInformation1 from './gameInformation1/GameInformation1';
import { getLocalTimeFromDatabaseTime } from '../../../catalog/DateTime';
import SocialsComponent4 from '../../uiElements/socialsComponents/socialsComponent4/SocialsComponent4';
import RugbyGameStats1 from './gameStats1/RugbyGameStats1';
import { SportsType } from '../../../catalog/enums/SportsType';
import GameTickets1 from './gameTickets1/GameTickets1';
import { showGameTickets, showProducts } from '../../../catalog/Store';
import LacrosseGameStats1 from './gameStats1/LacrosseGameStats1';
import FeaturedProducts3 from '../products1/FeaturedProducts3';

const Game1 = (props) => {
    const { id, title, game, featureImage, articleImage, opponentName, opponentLogo, status, homeGame, venue, timeOfGame, tags, galleryId, photos, galleryPublished, articleId, articleTitle, articleAuthor, articleContent, articlePublished, timeOfArticle, promotionalText, promotionalVideo, tickets, products, loadingSpinner, ticketsLoadingSpinner } = props;
    const params = useParams();
    const { globalState } = useContext(context);

    const getFeaturedProducts = () => {
        const featuredProducts = products.filter((product) => {
            return product.featureProduct && !product.deleted && product.published && !product.archived;
        });
        if (!showProducts(globalState, featuredProducts)) {
            return [];
        }
        return featuredProducts;
    };

    const gameStats = () => {
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return (
                <IceHockeyGameStats1
                    game={game}
                    opponentName={opponentName}
                    opponentLogo={opponentLogo}
                    homeGame={homeGame}
                />
            );
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return (
                <RugbyGameStats1
                    game={game}
                    opponentName={opponentName}
                    opponentLogo={opponentLogo}
                    homeGame={homeGame}
                />
            );
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return (
                <LacrosseGameStats1
                    game={game}
                    opponentName={opponentName}
                    opponentLogo={opponentLogo}
                    homeGame={homeGame}
                />
            );
        }
        return null;
    };

    return (
        <>
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    <GameFeatureImage1 title={title} game={game} featureImage={featureImage} opponentName={opponentName} opponentLogo={opponentLogo} status={status} homeGame={homeGame} venue={venue} timeOfGame={timeOfGame} />
                    <GameNavBar1 upcomingGame={getLocalTimeFromDatabaseTime(timeOfGame) > new Date()} articlePublished={articlePublished} galleryPublished={galleryPublished} showTickets={showGameTickets(globalState, tickets, timeOfGame, null)} showProducts={showProducts(globalState, products)}>
                        <Suspense fallback={<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />}>
                            <Switch>
                                <Route
                                    path="/games/:gameid/stats"
                                    exact
                                    render={() => {
                                        return gameStats();
                                    }}
                                />
                                <Route path="/games/:gameid/tickets" exact render={() => { return <GameTickets1 tickets={tickets} showTickets={showGameTickets(globalState, tickets, timeOfGame, null)} loadingSpinner={ticketsLoadingSpinner} />; }} />
                                <Route path="/games/:gameid/store" exact render={() => { return <FeaturedProducts3 products={getFeaturedProducts()} title="Store" />; }} />
                                <Route path="/games/:gameid/info" exact render={() => { return <GameInformation1 id={id} title={title} featureImage={featureImage} promotionalText={promotionalText} promotionalVideo={promotionalVideo} venue={venue} status={status} timeOfGame={timeOfGame} opponentName={opponentName} showTickets={showGameTickets(globalState, tickets, timeOfGame, null)} />; }} />
                                <Route path="/games/:gameid/roster" exact render={() => { return <GameRoster1 game={game} tags={tags} timeOfGame={timeOfGame} />; }} />
                                <Route path="/games/:gameid/social-media" exact render={() => { return <SocialsComponent4 />; }} />
                                <Route path="/games/:gameid/article" exact render={() => { return <ArticleComponent1 id={articleId} title={articleTitle} author={articleAuthor} featureImage={articleImage} content={articleContent} timeOfArticle={timeOfArticle} deleted={false} published={articlePublished} />; }} />
                                <Route path="/games/:gameid/gallery" exact render={() => { return <GalleryComponent1 id={galleryId} photos={photos} deleted={false} published={galleryPublished} />; }} />
                                <Route render={() => { return <Redirect to={{ pathname: `/games/${params.gameid}` }} />; }} />
                            </Switch>
                        </Suspense>
                    </GameNavBar1>
                </>
            )}
        </>
    );
};

Game1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    game: PropTypes.object.isRequired,
    featureImage: PropTypes.string.isRequired,
    articleImage: PropTypes.string.isRequired,
    opponentName: PropTypes.string.isRequired,
    opponentLogo: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    homeGame: PropTypes.bool.isRequired,
    venue: PropTypes.string.isRequired,
    timeOfGame: PropTypes.object.isRequired,
    tags: PropTypes.array.isRequired,
    galleryId: PropTypes.string.isRequired,
    photos: PropTypes.array.isRequired,
    galleryPublished: PropTypes.bool.isRequired,
    articleId: PropTypes.string.isRequired,
    articleTitle: PropTypes.string.isRequired,
    articleAuthor: PropTypes.string.isRequired,
    articleContent: PropTypes.string.isRequired,
    articlePublished: PropTypes.bool.isRequired,
    timeOfArticle: PropTypes.object.isRequired,
    promotionalText: PropTypes.string.isRequired,
    promotionalVideo: PropTypes.object.isRequired,
    tickets: PropTypes.array.isRequired,
    products: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
    ticketsLoadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Game1);
